import { render, staticRenderFns } from "./WarehouseCare.vue?vue&type=template&id=7ec13142&"
import script from "./WarehouseCare.vue?vue&type=script&lang=js&"
export * from "./WarehouseCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports